export default __webpack_public_path__ + "static/media/veal_thumb.13ff93e4.jpg";